/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

export enum MortalityCommentEnum {
  InactiveHarvest = 'INACTIVE_HARVEST',
  NormalHarvest = 'NORMAL_HARVEST',
  OveractiveHarvest = 'OVERACTIVE_HARVEST',
  DullSickBirds = 'DULL_SICK_BIRDS',
  LameBirds = 'LAME_BIRDS',
  BirdsAppearCold = 'BIRDS_APPEAR_COLD',
  BirdsAppearHot = 'BIRDS_APPEAR_HOT',
  WetLitter = 'WET_LITTER',
  CappedLitter = 'CAPPED_LITTER',
  WetDroppings = 'WET_DROPPINGS',
  BloodInDroppings = 'BLOOD_IN_DROPPINGS',
  UndigestedGrainsInDroppings = 'UNDIGESTED_GRAINS_IN_DROPPINGS',
  FeedFlicking = 'FEED_FLICKING',
  WholeWheatPassage = 'WHOLE_WHEAT_PASSAGE',
  BirdsRejectingFeed = 'BIRDS_REJECTING_FEED',
  FeedOutage = 'FEED_OUTAGE',
  WaterOutage = 'WATER_OUTAGE',
  WaterLeak = 'WATER_LEAK',
  VentilationIssue = 'VENTILATION_ISSUE'
}
